'use client';

import React, { createContext, useEffect, useState } from 'react';
import colors from '../../styles/colors/index.module.scss';


type ColorContext = {
  primaryColor: string | null,
  secondaryColor: string | null,
  setPrimaryColor: (color: string) => void,
  setSecondaryColor: (color: string) => void,
}

const Context = createContext({} as ColorContext);

export const ColorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [primaryColor, setPrimaryColor] = useState<null | string>(null);
  const [secondaryColor, setSecondaryColor] = useState<null | string>(null);

  useEffect(() => {
    const root = document.documentElement;
    const re = `/${colors.primary}/g`;
    const style = getComputedStyle(root).cssText;

    const newStyle = style.replace(re, primaryColor || colors.primary);
    root.style.cssText = newStyle;
  }, [primaryColor]);

  return (
    <Context.Provider value={{
      primaryColor,
      secondaryColor,
      setPrimaryColor,
      setSecondaryColor,
    }}
    >
      {children}
    </Context.Provider>
  );
};

export const useColor = () => React.useContext(Context);
